<template>
	<div class="form-group mod">
		<label :for="id" class="form-label">
			{{ title }}
		</label>
		<input
			type="month"
			class="form-control" :id="id"
			:placeholder="placeholder"
			v-model="value"
			@change="getDate"
		/>
	</div>
</template>

<script>
export default {
	name: "SOInputDate",
	props: {
		title: String,
		id: String,
		placeholder: String,
		value: String,
		minDate: String,
		maxDate: String,
	},
	mounted() {
		if (this.maxDate !== "") {
			$("#" + this.id).attr("max", this.maxDate)
		}
		if (this.minDate !== "") {
			$("#" + this.id).attr("max", this.minDate)
		}
	},
	methods: {
		getDate() {
			this.$emit("get-date", this.value)
		}
	}
}
</script>